import PageLoadedQueue from "./PageLoadedQueue";

PageLoadedQueue.addFunction(() => {
   const pageHeroSlider = document.querySelector('.homepage-hero-slider');
   const pageHeader = document.querySelector('#page-header');

    if (pageHeroSlider && pageHeader) {
        document.body.classList.add('remove-padding-top');

        const checkScroll = () => {
            if (window.scrollY > 100) {
                pageHeader.classList.remove('at-top');
            } else {
                pageHeader.classList.add('at-top');
            }
        }

        window.addEventListener('scroll', () => {
            checkScroll();
        });

        checkScroll();
    }
});
